<template>
  <b-row>
    <StepperCol :step="9" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        配管を通す「穴」の位置は？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{ a0Selected ? "壁の外" : "壁の中" }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : "¥11,000~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <h5 v-if="skipped" class="text-muted">穴がない</h5>
      <template v-else>
        <b-collapse v-model="isCollapsed">
          <b-row>
            <b-col cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-145px q1"
                :class="a0Selected ? 'selected' : ''"
                @click="buttonClicked(0)"
              >
                <div
                  class="position-relative bg-cover h-100"
                  :style="
                    'background-image: url(' +
                    require('@/assets/images/q-9-1@2x.png') +
                    ')'
                  "
                >
                  <h6
                    class="h5 pt-2 px-3 position-absolute"
                    style="top: 0px; right: 0"
                  >
                    穴が外まで<br />同じ位置で<br />貫通している
                  </h6>
                  <dl
                    class="text-muted mb-0 position-absolute"
                    style="bottom: 10px; left: 15px"
                  >
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </div>
              </b-button>
            </b-col>
            <b-col cols="12" md="6" lg="5" class="mb-3">
              <b-button
                class="btn-gd text-left h-145px p-0 q1"
                :class="a1Selected ? 'selected' : ''"
                @click="buttonClicked(1)"
              >
                <div
                  class="position-relative bg-cover h-100"
                  :style="
                    'background-image: url(' +
                    require('@/assets/images/q-9-2@2x.png') +
                    ')'
                  "
                >
                  <h6
                    class="h5 pt-2 px-3 position-absolute"
                    style="top: 0px; right: -10px"
                  >
                    室内側と屋外側で<br />穴の位置が違う<br />（隠蔽配管）
                  </h6>
                  <dl
                    class="text-muted mb-0 position-absolute"
                    style="bottom: 10px; left: 15px"
                  >
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">11,000~</span>
                    </dd>
                  </dl>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      skipped: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 9) {
        this.collapsed = true;
      }
    },
    hasHole(val, old) {
      old; // eslint-disable-line
      if (val == 1 || val == 2) {
        this.skipped = true;
        this.a0Selected = true;
        this.a1Selected = false;
      } else {
        this.skipped = false;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      hasHole() {
        return this.$store.getters.hasHole;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = true;
      }
      this.doSaveAnswer({ keyword: 'hole_type', answer: value });
      this.doUpdateStep(10);
      this.shrinking = true;
      console.log("google:配管を通す「穴」の位置は？");
    },
  },
};
</script>